import { sessionService } from '@rammetec/core'
import { repositoryResolver } from '@rammetec/data-access'
import type { Session } from '@syscolect/domain'

let initPromise: Promise<void> | null = null

export async function ensureConsoleSession(): Promise<void> {
  if (!initPromise) {
    initPromise = sessionService.init({
      onCreateSession: async (sessionDoc) => {
        const repo = await repositoryResolver.resolve<Session>('Session')
        await repo.create(sessionDoc as unknown as Session)
      },
      getDate: () => new Date(),
    })
  }
  return initPromise
}

export function getConsoleSessionInfo() {
  return {
    sessionId: sessionService.getCombinedSessionId(),
    sessionHash: sessionService.getSessionHash(),
  }
}
